export enum Position {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}

export enum Orientation {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}
